module.exports = __webpack_public_path__ + "img/10.c5fcb4f3.png";